import { render, staticRenderFns } from "./ServiceTaskDeal.vue?vue&type=template&id=fb07f936&scoped=true"
import script from "./ServiceTaskDeal.vue?vue&type=script&lang=js"
export * from "./ServiceTaskDeal.vue?vue&type=script&lang=js"
import style0 from "./ServiceTaskDeal.vue?vue&type=style&index=0&id=fb07f936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb07f936",
  null
  
)

export default component.exports